// Wires every .stp-theme-toggle button on the page (there's normally
// just one, but this is safe if a template ever renders it twice).
// Toggling flips document.documentElement's data-stp-theme attribute
// (which component-dark-mode.css keys off) and saves the choice so the
// early inline script in layout/theme.liquid can re-apply it before
// first paint on the next page load, site-wide.
(function () {
  function isDark() {
    return document.documentElement.getAttribute('data-stp-theme') === 'dark';
  }

  function syncButtons() {
    var dark = isDark();
    document.querySelectorAll('.stp-theme-toggle').forEach(function (btn) {
      btn.setAttribute('aria-pressed', dark ? 'true' : 'false');
      btn.setAttribute('aria-label', dark ? 'Switch to light theme' : 'Switch to dark theme');
    });
  }

  function toggle() {
    if (isDark()) {
      document.documentElement.removeAttribute('data-stp-theme');
      try { localStorage.setItem('stp-theme', 'light'); } catch (e) {}
    } else {
      document.documentElement.setAttribute('data-stp-theme', 'dark');
      try { localStorage.setItem('stp-theme', 'dark'); } catch (e) {}
    }
    syncButtons();
  }

  document.querySelectorAll('.stp-theme-toggle').forEach(function (btn) {
    btn.addEventListener('click', toggle);
  });
  syncButtons();
})();
